import React, { useState, useEffect, useRef } from "react";
import "../../../styles/SessionPage.css";
import logo from "../../../assets/icons/logo.svg";
import logoNew from "../../../assets/icons/NewLogo.png";
import { FaMicrophoneSlash } from "react-icons/fa";
import Lottie from "lottie-react";
import audioAnim from "../../../assets/icons/audio.json";
import dietician from "../../../assets/icons/dietician.svg";
import psychologist from "../../../assets/icons/psychologistai.svg";
import aipsychologistIcon from "../../../assets/icons/aipsychologist.svg";
import aidieticianIcon from "../../../assets/icons/aidietician.svg";


import { ReactComponent as VideoIcon } from "../../../assets/icons/video.svg";
import { ReactComponent as VoiceAudioIcon } from "../../../assets/icons/audiomic.svg";
import { ReactComponent as AiModelIcon } from "../../../assets/icons/aimodel.svg";
import { ReactComponent as EndCallIcon } from "../../../assets/icons/endcall.svg";
import { ReactComponent as VoiceModelIcon } from "../../../assets/icons/voicemodel.svg";

import { useNavigate } from "react-router-dom";
import { useWebSocketChat } from "../../../socket/useSocket";
import { AuthServices } from "../../auth/services/AuthServices.js";

const SessionPage = () => {
  const navigate = useNavigate();
  localStorage.setItem("chat_mode", "audio");

  const [selectedExpert, setSelectedExpert] = useState(() => {
    return localStorage.getItem("selectedExpert") || "";
  });
  const [isMuted, setIsMuted] = useState(false);
  const [showVoiceModal, setShowVoiceModal] = useState(false);
  const [showModelModal, setShowModelModal] = useState(false);
  const [showEndModal, setShowEndModal] = useState(false);
  const [showVideoConfirmModal, setShowVideoConfirmModal] = useState(false);
  const [selectedVoice, setSelectedVoice] = useState(null);
  const [selectedModelType, setSelectedModelType] = useState(selectedExpert);
  const [sessionEnded, setSessionEnded] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const [fadeOut, setFadeOut] = useState(false);
  const [modalMessage, setModalMessage] = useState(false);
  const [currentSubtitle, setCurrentSubtitle] = useState("");
  const [subtitleLines, setSubtitleLines] = useState([]);
  const [subtitles, setSubtitles] = useState([]);
  const [subtitleText, setSubtitleText] = useState(""); // full text of current audio
  const [highlightIndex, setHighlightIndex] = useState(0); // index of highlighted char



  const {
    socket,
    updatePatientId,
    sendAudio,
    audioChunksRef,
    setBotStatus,
    botStatus,
    updatePersona,
  } = useWebSocketChat({
    setCompleteAudio: (data) => handleAudioComplete(data),
    onStreamingStart: (data) => handleStreamingStart(data),
    onStreamingText: (data) => data,
    onStreamingAudio: (data) => handleStreamAudio(data),
    onStreamingComplete: (data) => handleStreamingComplete(data),
    onStreamingError: (data) => handleStreamError(data),
    onTranscription: () => { },
    onConversationHistory: () => { },
  });

  const [user, setUser] = useState();
  const audioRef = useRef(new Audio());
  const audioQueue = useRef([]);
  const isProcessingQueue = useRef(false);
  const streamRef = useRef(null);
  const mediaRecorderRef = useRef(null);
  const isRecordingRef = useRef(false);
  const lottieRef = useRef(null);

  const handleAudioComplete = (data) => { };

  const handleStreamingStart = () => {
    setBotStatus("thinking");
  };

  const handleModelSelect = (type) => {
    setSelectedModelType(type.target.innerText);
  };
  // map status -> visual tint
  const animFilter =
    botStatus === "listening"
      ? "hue-rotate(320deg) saturate(1.25) brightness(1.05)"
      : botStatus === "thinking"
        ? "hue-rotate(160deg) saturate(1.15)"
        : "none";

  useEffect(() => {
    if (!lottieRef.current) return;
    if (botStatus === "listening") lottieRef.current.setSpeed(1.15);
    else if (botStatus === "thinking") lottieRef.current.setSpeed(0.7);
    else lottieRef.current.setSpeed(1);
  }, [botStatus]);



  const handleSendSelectedModel = () => {
    setSelectedExpert(selectedModelType);
    localStorage.setItem("selectedExpert", selectedModelType);
    updatePersona(selectedModelType);
    setShowModelModal(false);
    setModalMessage("Transfering to "+selectedModelType);

    //localStorage.setItem("conversation_id", null);

    if (socket && socket.readyState === 1) {
      socket.close();
    }

    setTimeout(() => {
    // Start fade-out
    setFadeOut(true);
   
    // Preload current page in hidden iframe
  const iframe = document.createElement("iframe");
  iframe.style.display = "none";
  iframe.src = window.location.href;

  iframe.onload = () => {
    // After fade completes (same as your animation time)
    setTimeout(() => {
      setFadeOut(false); // reset fade
      setModalMessage(false);
      // Optional: you can reset state or force remount
      // Forcing navigation to same route using React Router
      navigate(window.location.pathname, { replace: true, state: { reload: true } });
    }, 200); // match fade-out duration
  };

  document.body.appendChild(iframe);
  }, 1000);

    

    //window.location.reload();
  };




  const handleSetVoice = (voice) => {
    setSelectedVoice(voice.target.innerText);
  };
   

  const handleVoiceSelect = () => {
    let mappedVoice;
    setModalMessage("Changing model voice to "+selectedVoice);

    switch (selectedVoice) {
      case "Nova – Female, Soft":
        mappedVoice = "nova";
        break;
      case "Alloy – Neutral":
        mappedVoice = "alloy";
        break;
      case "Echo – Male":
        mappedVoice = "echo";
        break;
      case "Fable – Female":
        mappedVoice = "fable";
        break;
      case "Onyx – Male, Deep":
        mappedVoice = "onyx";
        break;
      case "Shimmer – Female, Clear":
        mappedVoice = "shimmer";
        break;
      default:
        mappedVoice = "default";
    }

    localStorage.setItem("selectedVoice", mappedVoice);

    setTimeout(() => {
                // Start fade-out
              setFadeOut(true);
        
                // Preload current page in hidden iframe
              const iframe = document.createElement("iframe");
              iframe.style.display = "none";
              iframe.src = window.location.href;
              document.body.appendChild(iframe);

              iframe.onload = () => {
            // After fade completes (same as your animation time)
              setTimeout(() => {
              
              
              setModalMessage(false);

              setFadeOut(false); // reset fade
              // Optional: you can reset state or force remount
              // Forcing navigation to same route using React Router
              window.location.reload();
              //navigate(window.location.pathname, { replace: true, state: { reload: true } });
            }, 200); // match fade-out duration
        };

        //document.body.appendChild(iframe);
        
        }, 1000);

    //window.location.reload();

    setShowVoiceModal(false);
  };

  const handleStreamAudio = (data) => {
    if (!data || !data.audio) return;
    //enqueueAudio(data.audio);
    const text = data.text || "…"; // get subtitle text from server
    //enqueueAudioWithSubtitle(data.audio, text);

      
      enqueueAudio(data.audio, text);

    };

  const handleStreamingComplete = (data) => {
    console.log("Bot finished responding.");
    //setBotStatus(null);
    
    if (!sessionEnded) {
    startRecording();
  }

  };


  //-----------------------------------------------------------------

// Queue both audio and its corresponding subtitle text
const enqueueAudioWithSubtitle = (audioData, text) => {
  const blob = new Blob(
    [Uint8Array.from(atob(audioData), (c) => c.charCodeAt(0))],
    { type: "audio/mpeg" }
  );

  audioQueue.current.push({ blob, text });

  // Only start processing if not already running
  if (!isProcessingQueue.current) processAudioQueueWithSubtitle();
};

const processAudioQueueWithSubtitle = async () => {
  const audio = audioRef.current;
  if (!audio) {
    console.warn("Audio element not ready yet");
    return;
  }

  if (audioQueue.current.length === 0) {
    isProcessingQueue.current = false;
    return;
  }

  isProcessingQueue.current = true;
  const { blob, text } = audioQueue.current.shift();
  const url = URL.createObjectURL(blob);

  try {
    // Display subtitle before playing
    setSubtitleLines(prev => {
      const newLines = [...prev, text];
      return newLines.slice(-2); // keep only last 2 lines
    });

    audio.src = url;
    await audio.play();

    audio.onended = () => {
      URL.revokeObjectURL(url);
      processAudioQueueWithSubtitle(); // recursively play next
    };
  } catch (err) {
    console.error("Audio playback error:", err);
    URL.revokeObjectURL(url);
    isProcessingQueue.current = false;
  }
};


  //-----------------------------------------------------------------


  /*const enqueueAudio = (audioData) => {
    const blob = new Blob(
      [Uint8Array.from(atob(audioData), (c) => c.charCodeAt(0))],
      {
        type: "audio/mpeg",
      }
    );
    audioQueue.current.push(blob);
    if (!isProcessingQueue.current) processAudioQueue();
  };

  const processAudioQueue = async () => {
    const audio = audioRef.current;
    if (!audio) {
      console.warn("Audio element not ready yet");
      return;
    }

    if (audioQueue.current.length === 0) {
      isProcessingQueue.current = false;
      return;
    }

    isProcessingQueue.current = true;
    const blob = audioQueue.current.shift();
    const url = URL.createObjectURL(blob);

    try {
      audio.src = url;
      await audio.play();

      audio.onended = () => {
        URL.revokeObjectURL(url);
        processAudioQueue();
      };
    } catch (err) {
      console.error("Audio playback error:", err);
      URL.revokeObjectURL(url);
      isProcessingQueue.current = false;
    }
  };
*/


//-----------------------------------------------------------------------

// Queue format: { audioData: base64, text: subtitle string }
//const audioQueue = useRef([]);
//const isProcessingQueue = useRef(false);

// Audio queue & processing
const enqueueAudio = (audioData, text) => {
  audioQueue.current.push({ audioData, text });
  if (!isProcessingQueue.current) processAudioQueue();
};

const processAudioQueue = async () => {
  const audio = audioRef.current;
  if (!audio) return;
  if (audioQueue.current.length === 0) {
    isProcessingQueue.current = false;
    setSubtitleText("");
    setHighlightIndex(0);
    return;
  }

  isProcessingQueue.current = true;
  const { audioData, text } = audioQueue.current.shift();
  const blob = new Blob([Uint8Array.from(atob(audioData), (c) => c.charCodeAt(0))], { type: "audio/mpeg" });
  const url = URL.createObjectURL(blob);

  audio.src = url;
  setSubtitleText(text);
  setHighlightIndex(0);

  try {
    await audio.play();

    const words = text.split(" ");
    const duration = audio.duration || 3; // fallback
    const intervalTime = duration / words.length;

    let idx = 0;
    const interval = setInterval(() => {
      if (idx >= words.length) {
        clearInterval(interval);
        setHighlightIndex(0);
        return;
      }
      setHighlightIndex(idx);
      idx++;
    }, intervalTime * 1000);

    audio.onended = () => {
      clearInterval(interval);
      setHighlightIndex(0);
      URL.revokeObjectURL(url);
      processAudioQueue();
    };
  } catch (err) {
    console.error("Audio playback error:", err);
    URL.revokeObjectURL(url);
    isProcessingQueue.current = false;
  }
};




//----------------------------------------------------------------------
  const startRecording = async () => {
    if (!audioRef.current?.paused) {
      console.log("Bot audio is still playing. Waiting to start recording...");
      setTimeout(() => {
        startRecording();
      }, 500);
      return;
    }
    if (!navigator.mediaDevices || !window.MediaRecorder) {
      alert("Audio recording is not supported in this browser.");
      return;
    }

    setBotStatus("listening");
    console.log("Recording started...");
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        audio: true,
      });
      streamRef.current = stream;

      const mediaRecorder = new MediaRecorder(stream, {
        mimeType: "audio/webm",
      });

      mediaRecorderRef.current = mediaRecorder;
      audioChunksRef.current = [];

      mediaRecorder.ondataavailable = (event) => {
        if (event.data.size > 0) {
          audioChunksRef.current.push(event.data);
        }
      };

      mediaRecorder.onstop = async () => {
        console.log("MediaRecorder stopped. Sending audio...");
        setBotStatus("thinking");
        await sendAudio();
        isRecordingRef.current = false;
        stream.getTracks().forEach((track) => track.stop());
        mediaRecorderRef.current = null;
      };

      mediaRecorder.start();
      isRecordingRef.current = true;

      detectSilence(stream, 2000, 0.01, () => {
        stopRecording();
        isRecordingRef.current = false;
      });
    } catch (error) {
      console.error("Microphone error:", error);
      alert(`Microphone error: ${error.message}`);
    }
  };

  const handleStreamError = (data) => { };

  const detectSilence = (
    stream,
    silenceDuration = 2000,
    threshold = 0.01,
    onSilence = () => { }
  ) => {
    const audioCtx = new (window.AudioContext || window.webkitAudioContext)();
    const analyser = audioCtx.createAnalyser();
    const source = audioCtx.createMediaStreamSource(stream);
    const data = new Uint8Array(analyser.fftSize);

    source.connect(analyser);

    let silenceStart = null;
    let startedTalking = false;

    const checkSilence = () => {
      analyser.getByteTimeDomainData(data);

      let sum = 0;
      for (let i = 0; i < data.length; i++) {
        const val = (data[i] - 128) / 128;
        sum += val * val;
      }
      const volume = Math.sqrt(sum / data.length);

      if (volume > threshold) {
        startedTalking = true;
        silenceStart = null;
      }

      if (startedTalking) {
        if (volume < threshold) {
          if (!silenceStart) silenceStart = performance.now();
          if (performance.now() - silenceStart > silenceDuration) {
            onSilence();
            audioCtx.close();
            return;
          }
        } else {
          silenceStart = null;
        }
      }

      requestAnimationFrame(checkSilence);
    };

    checkSilence();
  };

  const stopRecording = () => {
    if (mediaRecorderRef.current && isRecordingRef.current) {
      mediaRecorderRef.current.stop();
      isRecordingRef.current = false;
    }
  };

  const handleMuteToggle = () => {
    const audioTracks = streamRef.current?.getAudioTracks();
    if (audioTracks && audioTracks.length > 0) {
      const current = audioTracks[0];
      current.enabled = !current.enabled;
      setIsMuted(!isMuted);
    }
  };

  const handleEndCall = () => {
    setShowEndModal(true);
  };

  const fetchUserData = async () => {
    try {
      const response = await AuthServices.fetchUserData();
      const fetchedUser = response?.data?.data?.user;

      if (response.status !== 200) {
        socket?.close();
        localStorage.clear();
        navigate("/");
      }

      if (fetchedUser) {
        setUser(fetchedUser);
        localStorage.setItem("user", JSON.stringify(fetchedUser));

        if (fetchedUser?.patient_id) {
          updatePatientId(fetchedUser.patient_id);
        }
      }
    } catch (error) {
      console.error("Failed to fetch user data:", error);
    }
  };

  /*const handleEndNow = () => {
    if (socket?.readyState === 1) {
      socket.close();
    }
    window.location.href = "/home";
  };*/
  // -- Idle modal state
  const [showIdleModal, setShowIdleModal] = useState(false);

  useEffect(() => {
    const INACTIVE_MS = 10 * 60 * 1000;
    const POLL_MS = 1_000;      // check every second
    const KEY = "lastActivityAt";

    const stamp = () => {
      localStorage.setItem(KEY, String(Date.now()));
      if (showIdleModal) setShowIdleModal(false);
    };

    // seed once on mount
    if (!localStorage.getItem(KEY)) stamp();

    // user activity listeners
    const events = ["click", "keydown", "mousemove", "touchstart", "scroll"];
    events.forEach((e) => window.addEventListener(e, stamp, { passive: true }));

    // when tab becomes visible, treat as activity
    const onVis = () => { if (!document.hidden) stamp(); };
    document.addEventListener("visibilitychange", onVis);

    // simple poll to check idle time
    const poll = setInterval(() => {
      const last = Number(localStorage.getItem(KEY) || 0);
      if (!last) return stamp();
      if (Date.now() - last > INACTIVE_MS) setShowIdleModal(true);
    }, 15000); // check every 15s

    return () => {
      events.forEach((e) => window.removeEventListener(e, stamp));
      document.removeEventListener("visibilitychange", onVis);
      clearInterval(poll);
    };
  }, [showIdleModal]);

  // -- Buttons
  const handleStayActive = () => {
    localStorage.setItem("lastActivityAt", String(Date.now()));
    setShowIdleModal(false);
    setShowEndModal(false);
  };

 //--------------------------------------------------------------

const cleanupSession = async () => {
  console.log("[cleanup] starting...");

  // Stop MediaRecorder if running
  if (mediaRecorderRef.current) {
    try {
      if (mediaRecorderRef.current.state !== "inactive") {
        mediaRecorderRef.current.stop();
      }
    } catch (err) {
      console.warn("error stopping mediaRecorder", err);
    }
    mediaRecorderRef.current.ondataavailable = null;
    mediaRecorderRef.current.onstop = null;
    mediaRecorderRef.current = null;
    isRecordingRef.current = false;
  }

  // Stop mic/camera stream
  if (streamRef.current) {
    streamRef.current.getTracks().forEach(track => {
      try { track.stop(); } catch (err) {}
    });
    streamRef.current = null;
  }

  // Stop <audio> playback
  audioQueue.current = [];
  if (audioRef.current) {
    try {
      audioRef.current.pause();
      audioRef.current.src = "";
    } catch (err) {}
  }

  // Also stop <video> element stream if needed
  /*if (userVideoRef.current?.srcObject) {
    const videoStream = userVideoRef.current.srcObject;
    videoStream.getTracks().forEach(track => {
      try { track.stop(); } catch (err) {}
    });
    userVideoRef.current.srcObject = null;
  }
*/
  console.log("[cleanup] completed.");
};

//-----------------------------------------------


const cleanText = (htmlText) => {
    if (!htmlText) return "";
    return htmlText.replace(/<br\s*\/?>/gi, "\n").replace(/<\/?strong>/gi, "");
  };


// helper to play audio + show subtitle
const playAudioWithSubtitle = async (audioBlob, subtitleText) => {
  if (!audioRef.current) return;

  const url = URL.createObjectURL(audioBlob);
  audioRef.current.src = url;

  // update subtitles (keep max 2 lines)
  setSubtitles((prev) => {
    const updated = [...prev, subtitleText];
    return updated.slice(-2); // only last 2
  });

  audioRef.current.play().catch((err) => {
    console.warn("audio play failed:", err);
  });

  audioRef.current.onended = () => {
    URL.revokeObjectURL(url);
  };
};



 //--------------------------------------------------------------


const handleEndSession = () => {
  setSessionEnded(true);
  cleanupSession();
  setShowIdleModal(false);

  setIsClosing(true);
  setShowEndModal(true);

  // Wait 1s to show closing modal
  setTimeout(() => {
    // Start fade-out
    setFadeOut(true);

    // Preload /home in hidden iframe
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = "/home";

    iframe.onload = () => {
      // After fade completes (0.8s), switch
      setTimeout(() => {
        setShowEndModal(false);
        navigate("/home", { replace: true ,
                                            state: { 
                                            ischatVisible: true,    // pass any data you want
                                            session: localStorage.getItem("conversation_id") ??  null
                                            }
                                });
        window.location.href = "/home";
      }, 200);
    };

    document.body.appendChild(iframe);
  }, 1000);
};


useEffect(() => {
    if (socket?.readyState === 1 && user?.patient_id) {
      const initRecording = async () => {
        await startRecording();
      };
      initRecording();
    }
  }, [socket]);

  useEffect(() => {
    if (audioRef.current) {
      processAudioQueue();
    }
  }, []);

  useEffect(() => {
    const getUser = async () => {
      fetchUserData();
    };
    getUser();
  }, []);

  useEffect(() => {
    if (user?.patient_id) {
      updatePersona(selectedExpert);
    }
  }, [user]);

  return (
    <div className="session-container">
      <audio ref={audioRef} style={{ display: "none" }} />

      <div className="session-info">
        <img src={logo} alt="Bot Avatar" className="session-avatar" />
        <p>
          You are having audio conversation with our AI {' '}
          {selectedModelType==="psychologist"? "Therapist" : "Dietician"}
        </p>

      </div>
      {/* centered overlay; sits above the page, doesn’t shift layout */}
      <div className="session-center-stack" aria-hidden="true">

       
        <div className="session-anim" style={{ filter: animFilter, transition: "filter 160ms ease" }}>
          <Lottie animationData={audioAnim} loop autoplay />
          <img
            src={selectedModelType === "dietician" ? dietician : psychologist}
            alt="Model Avatar"
            style={{
              borderRadius: "50%",
              width: "100px",
              height: "100px",
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)", // centers perfectly
            }}
  />
        </div>

       
        {botStatus && (
          <div className={`bot-indicator below ${botStatus}`}
          style={{position: "fixed"}}>
            {console.log("botStatus-audio:",botStatus)}
             {botStatus === "listening" ? "Listening" : "Thinking"}
          </div>
        )}




       
          <div 
          style={{
                  position: "fixed",      // Fix at screen
                          // Distance from bottom
                  left: "50%", 
                  top: "35vh"  ,        // Center horizontally
                  transform: "translateX(-50%)", // Center alignment
                  fontSize: "24px",
                  /*background: "rgba(249, 244, 244, .9)", // Optional semi-transparent background*/
                  padding: "8px 16px",
                  width:"100%",
                  borderRadius: "8px",
                  whiteSpace: "nowrap",
                  overflowX: "hidden",
                  zIndex: 1000,           // Make sure it's on top
                }}
          >
            {cleanText(subtitleText).split(" ").map((word, idx) => {
              const maxVisibleWords = 5; // show around 5 words at a time
              const start = Math.max(0, highlightIndex - 2); // center highlight
              const end = start + maxVisibleWords;

              if (idx < start || idx >= end) return null;

              const isHighlighted = idx === highlightIndex;

              return (
                <span
                  key={idx}
                  style={{
                    color: isHighlighted ? "#ff0019ff" : "#000",
                    fontStyle: isHighlighted ? "bold" :"normal",
                    fontSize:  isHighlighted ? "30px" :"24px",
                    transition: "color 0.1s linear",
                    marginRight: "4px",
                    display: "inline-block",
                  }}
                >
                  {word}
                </span>
              );
            })}
          </div>
          












      </div>

      <footer className="session-controls">
        {/*<button className="circle-btn" onClick={handleMuteToggle}>*/}
          <button className="circle-btn" onClick={handleMuteToggle}>
            {isMuted ? (
              <FaMicrophoneSlash color="#f00" size={20} />
            ) : (
              <VoiceAudioIcon width={20} height={20} />
            )}
          </button>
       {/* </button>*/}
        <button
          className="circle-btn"
          onClick={() => setShowVideoConfirmModal(true)}
        >
          <VideoIcon width={20} height={20} />
        </button>

        {/* <button className="circle-btn" onClick={() => setShowModelModal(true)}>
          <AiModelIcon width={20} height={20} />
        </button> */}
        <button className="circle-btn" 
        aria-label={selectedExpert === "dietician" ? "Change to Therapist" : "Change to Dietician"}
        onClick={() => {
          const newModel = selectedExpert === "dietician" ? "psychologist" : "dietician";
          const dispmodel = selectedExpert==="psychologist" ? "Dietician" : "Therapist";
          setModalMessage("Transfering to "+dispmodel);
          setSelectedExpert(newModel);
          localStorage.setItem("selectedExpert", newModel);
         // updatePersona(newModel);
          //localStorage.setItem("conversation_id", null);
          if (socket && socket.readyState === 1) {
            socket.close();
          }
          
          setTimeout(() => {
          // Start fade-out
         setFadeOut(true);
   
          // Preload current page in hidden iframe
        const iframe = document.createElement("iframe");
        iframe.style.display = "none";
        iframe.src = window.location.href;
        document.body.appendChild(iframe);

        iframe.onload = () => {
      // After fade completes (same as your animation time)
        setTimeout(() => {
        
        updatePersona(newModel);
        setModalMessage(false);

        setFadeOut(false); // reset fade
        // Optional: you can reset state or force remount
        // Forcing navigation to same route using React Router
        window.location.reload();
        //navigate(window.location.pathname, { replace: true, state: { reload: true } });
      }, 200); // match fade-out duration
  };

  document.body.appendChild(iframe);
  
  }, 1000);

        

          //window.location.reload();
        }}>
          <AiModelIcon width={20} height={20} title={selectedExpert === "dietician" ? "Change to Therapist" : "Change to Dietician"} />

        </button>
        <button className="circle-btn" onClick={() => setShowVoiceModal(true)}>
          <VoiceModelIcon width={20} height={20} />
        </button>
        <div className="divider" />
        <button className="circle-btn end-call" onClick={handleEndCall}>
          <EndCallIcon width={20} height={20} />
        </button>
      </footer>
      {/* Model Selection Modal */}
      {showModelModal && (
        <div className="voice-modal-overlay">
          <div className="voice-modal">
            <div className="modal-header-indicator" />
            <h3>Choose Your AI Model</h3>
            <ul className="voice-list">
              {["psychologist", "dietician"].map((model, index) => (
                <li
                  style={{
                    backgroundColor:
                      model === selectedModelType ? "#dfefff" : "",
                    cursor: "pointer",
                    borderRadius: "8px",
                    padding: "10px",
                    transition: "0.2s",
                  }}
                  key={index}
                  className="voice-item"
                  onClick={handleModelSelect}
                >
                  <span>{model}</span>
                </li>
              ))}
            </ul>
            <div className="modal-actions">
              <button
                className="cancel"
                onClick={() => setShowModelModal(false)}
              >
                Cancel
              </button>
              <button
                className="done"
                disabled={!selectedModelType}
                onClick={handleSendSelectedModel}
              >
                Done
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Voice Selection Modal */}
      {showVoiceModal && (
        <div className="voice-modal-overlay">
          <div className="voice-modal">
            <div className="modal-header-indicator" />
            <h3>Choose Your AI Model Voice</h3>
            <ul className="voice-list">
              {[
                "Nova – Female, Soft",
                "Alloy – Neutral",
                "Echo – Male",
                "Fable – Female",
                "Onyx – Male, Deep",
                "Shimmer – Female, Clear",
              ]
              .filter((voice) => {
            const lower = voice.toLowerCase();
            if (selectedModelType === "dietician") {
              // only female voices
              return lower.includes("female");
            } else {
              // only male or neutral, exclude female
              //lower.excludes("female");
              return (lower.includes("male") || lower.includes("neutral")) && !lower.includes("female");
            }
          })          
              .map((voice, index) => (
                <li
                  style={{
                    backgroundColor: selectedVoice === voice ? "#dfefff" : "",
                    cursor: "pointer",
                    borderRadius: "8px",
                    padding: "10px",
                    transition: "0.2s",
                  }}
                  key={index}
                  className="voice-item"
                  onClick={(index) => handleSetVoice(index)}
                >
                  <span>{voice}</span>
                </li>
              ))}
            </ul>
            <div className="modal-actions">
              <button
                className="cancel"
                onClick={() => setShowVoiceModal(false)}
              >
                Cancel
              </button>
              <button
                className="done"
                disabled={!selectedVoice}
                onClick={handleVoiceSelect}
              >
                Done
              </button>
            </div>
          </div>
        </div>
      )}
      {/* End Call Modal */}
      {showEndModal && (
        <div className={`voice-modal-overlay closing-fade ${fadeOut ? "fade-out" : ""}`}>
        <div className="voice-modal">

            {isClosing ? (
         
                <h3 style={{ color: "#7D4AEA", fontWeight: 600 }}>
                  Closing audio session...
                </h3>
              
      ) : (
        <>
        
            <h3 style={{ color: "#7D4AEA", fontWeight: 600 }}>
              Are you sure you want to end this call?
            </h3>
            <div className="modal-actions">
              
              <button className="cancel"  onClick={handleStayActive} >
                Stay on call
              </button>
              <button
                className="done" 
                  onClick={handleEndSession}
                  style={{
                  background: "#ff4d4f",
                  color: "white",
                  border: "none",
                }}
              >
                End Now
              </button>
            </div>
             </>
          )}
          </div>
        </div>
      )}





      {/* Video Confirmation Modal */}
      {showVideoConfirmModal && (
        <div className="voice-modal-overlay">
          <div className="voice-modal">
            <div className="modal-header-indicator" />
            <h3>Confirmation</h3>
            <p>
              To start a video session with <strong>{selectedExpert}</strong>?
            </p>
            <div className="modal-actions">
              <button
                className="cancel"
                onClick={() => setShowVideoConfirmModal(false)}
              >
                Stay in Audio
              </button>
              <button className="done" onClick={() => navigate("/vsession")}>
                Start
              </button>
            </div>
          </div>
        </div>
      )}
      {showIdleModal && (
        <div className="voice-modal-overlay">
          <div className="voice-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header-indicator" />
            <h3 style={{ fontWeight: 600, marginBottom: 6 }}>Still there?</h3>
            <p style={{ marginBottom: 14 }}>You’ve been inactive for a while.</p>
            <div className="modal-actions">
              <button className="cancel" onClick={handleStayActive}>Stay</button>
              <button className="done" onClick={handleEndSession}>End Session</button>
            </div>
          </div>
        </div>
      )}


      {modalMessage && (
      
      <div className="feedback-modal-overlay">
              <div className="feedback-modal">
            <img
              src={logoNew}
              alt="Prashasync Logo"
              className="modal-logo-google"
            />
            <h3>Please wait… </h3>
            <p>{modalMessage} </p>
          </div>
        </div>
      
        
      )}

    </div>
  );
};




export default SessionPage;
